import React from 'react'

// import PropTypes from 'prop-types'

import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import { camelCase } from 'lodash'

import {
  Dialog,
  Grid,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton
} from '@material-ui/core'
import { Close } from '@material-ui/icons'

import InputGroup from '../UI/Forms/InputGroup/InputGroup'
import Button from '../UI/Button/Button'

const FormModal = ({
  open,
  onCancel,
  onSubmit,

  form,
  onChange,

  size = 'md',
  header,
  showCloseButton,
  disableBackdropClick,

  customHeader,
  customContent,
  customFooter,

  children,
  translate
}) => {
  let formValid = true
  const formDisplay = Object.entries(form).map(formItem => {
    const [formKey, formAttrs] = formItem

    formValid = formValid && formAttrs.valid

    return (
      <InputGroup
        key={formKey}
        label={formAttrs.label}
        inputType={formAttrs.elementType}
        configs={formAttrs.elementConfig}
        invalid={!formAttrs.valid}
        validations={formAttrs.validation}
        touched={formAttrs.touched}
        changed={onChange}
        inputValue={formAttrs.value}
        validationError={formAttrs.error}
      />
    )
  })

  const closeButton = (
    <Grid item xs={2} style={{ textAlign: 'right' }}>
      <IconButton edge='end' color='inherit' onClick={onCancel} aria-label='close'>
        <Close />
      </IconButton>
    </Grid>
  )

  const defaultHeader = translate(camelCase(header)) || header
  const defaultContent = customContent || children || formDisplay
  const defaultFooter = (
    <Grid container justify={'flex-end'} spacing={1}>
      <Grid item xs sm={3} md={3} lg={2}>
        <Button type={'submit'} color={'primary'} disabled={!formValid}>
          {translate('save')}
        </Button>
      </Grid>
      <Grid item xs sm={3} md={3} lg={2}>
        <Button color={'default'} clicked={onCancel}>
          {translate('cancel')}
        </Button>
      </Grid>
    </Grid>
  )

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth={size}
      fullWidth={true}
      disableBackdropClick={disableBackdropClick}
      aria-labelledby='form-dialog-title'>
      <form onSubmit={onSubmit}>
        <DialogTitle id='form-dialog-title'>
          <Grid container spacing={3}>
            <Grid item xs={10}>
              {customHeader ? customHeader : defaultHeader}
            </Grid>
            {showCloseButton ? closeButton : null}
          </Grid>
        </DialogTitle>
        <DialogContent>{customContent ? customContent : defaultContent}</DialogContent>
        <DialogActions>{customFooter ? customFooter : defaultFooter}</DialogActions>
      </form>
    </Dialog>
  )
}

export default withTranslate(FormModal)
